import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task02 } from "../../../../../task/course-01/lesson-05/task-02";

const task: Slide = {
  title: "Derive the modulus of the reflection coefficient.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/01/05/task/task-2.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
